define('modules/integrations/services/zapier/index',['require','exports','module','./view'],function(require, exports, module) {
    "use strict";

    module.exports = {
        View: require("./view")
    };

});

